import { useDispatch, useSelector } from "react-redux";

import { VeteranAutoType } from "Store/interfaces/products/checkPrice/riskProducts/VehicleProducts/VeteranAuto";
import { ReduxState } from "Store/rootReducer";
import { isDefined } from "Utils/functions";
import { useEffect } from "react";
import { GetVeteranVehicleModelsEntity } from "./interfaces";
import { getVeteranVehicleModelStart } from "./slice";

export const useGetVeteranVehicleModel = (
  vehicleType: VeteranAutoType | undefined,
): GetVeteranVehicleModelsEntity => {
  const dispatch = useDispatch();
  const getVeteranVehicleModel = useSelector(
    (state: ReduxState) => state.getVeteranVehicleModel,
  );

  useEffect(() => {
    if (isDefined(vehicleType) && !getVeteranVehicleModel.current) {
      dispatch(getVeteranVehicleModelStart({ vehicleType }));
    }
  }, [vehicleType, getVeteranVehicleModel.current]);

  return getVeteranVehicleModel;
};
